import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        transform: scaleY(-1);\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        transform: scaleX(-1);\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    fill: ", ";\n    height: ", ";\n    pointer-events: none;\n    transform: translateZ(0); /* fix blurry icon issues */\n    width: ", ";\n\n    &:not(:root) {\n      overflow: visible;\n    }\n\n    ", "\n\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { color as colorVar } from '@scp/ui-shared/theme/variables';
import { getCSSUnitValue } from '@scp/ui-shared/theme/utils';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { iconMap } from './iconMap';
var E2E_SUFFIX = '-icon';

var getDefaultSVGConfig = function getDefaultSVGConfig(_ref) {
  var isImage = _ref.isImage,
      title = _ref.title;
  return {
    style: {
      color: null
    },
    focusable: 'false',
    role: isImage ? 'img' : undefined,
    'aria-hidden': !isImage && 'true',
    'aria-label': isImage && title ? title : undefined
  };
};

function applyDefaults(icon) {
  return styled(withoutProps(icon, PROPS_TO_OMIT)).attrs(getDefaultSVGConfig)(_templateObject(), function (props) {
    return props.color;
  }, function (props) {
    return getCSSUnitValue(props.height || props.size);
  }, function (props) {
    return getCSSUnitValue(props.width || props.size);
  }, function (props) {
    return props.flip === 'horizontal' && css(_templateObject2());
  }, function (props) {
    return props.flip === 'vertical' && css(_templateObject3());
  });
}

var PROPS_TO_OMIT = ['size', 'color', 'isImage', 'title'];
var iconsWithDefaults = Object.keys(iconMap).reduce(function (acc, key) {
  var iconKey = key;
  acc[iconKey] = applyDefaults(iconMap[iconKey]);
  return acc;
}, {});
/**
 * Icon component selects the imported icon (from `iconMap`) by given prop `name`.
 * Example usage: `<Icon name="logo" />`
 * In this case, a key with name "logo" should exist in `iconMap`.
 */

export var Icon = function Icon(_a) {
  var name = _a.name,
      _a$size = _a.size,
      size = _a$size === void 0 ? 24 : _a$size,
      _a$color = _a.color,
      color = _a$color === void 0 ? colorVar.icon : _a$color,
      rest = __rest(_a, ["name", "size", "color"]);

  var IconComponent = iconsWithDefaults[name];
  if (!IconComponent) return null;
  return React.createElement(IconComponent, Object.assign({
    color: color,
    size: size,
    "data-e2e": getE2eLabel(name, E2E_SUFFIX)
  }, rest));
};